(ns rlws.iot-cloud.frontend.events
  (:require ajax.core
            [clojure.string :as str]
            [fork.re-frame :as fork]
            [re-frame.core :as rf]
            [re-pressed.core :as rp]
            [rlws.iot-cloud.frontend.ajax :as ajax]
            [rlws.iot-cloud.frontend.authentication :as authn]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.config :as config]
            [rlws.iot-cloud.frontend.fx :as fx]
            [rlws.iot-cloud.frontend.global-messages :as global-messages]
            [rlws.iot-cloud.frontend.logging :as logging]
            [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.sse :as sse]
            [rlws.iot-cloud.frontend.assets.logic :as logic]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.frontend.navigation :as navigation]
            [rlws.iot-cloud.frontend.ajax-common :as ajax-common]
            [potpuri.core :as potpuri]))

(def dealership-image-data-interceptor
  (rf/on-changes (fn [{user-dealership :dealership} dealerships]
                   (when (and user-dealership dealerships)
                     (when-let [brand-logo-url
                                (some->> dealerships
                                         (filter #(= user-dealership
                                                     (-> (:crux.db/id %)
                                                         (str/split "/")
                                                         last)))
                                         not-empty
                                         first
                                         :customization
                                         :brand-logo)]
                           (rf/dispatch [::get-image-data brand-logo-url]))))
                 [:ajax-data :brand-logo] ;; Not actually used anywhere
                 [:ajax-data :current-user]
                 [:ajax-data :dealerships]))

(rf/reg-event-fx
 ::get-image-data
 (fn [_ [_ uri]]
   (ajax/request-image uri [::get-image-data-success] [::fetch-data-failure [:image]])))

(rf/reg-event-db
 ::get-image-data-success
 (fn [db [_ image-type response]]
   (let [response-str (if (= "png" image-type)
                        (->> response
                            (js/Uint8Array.)
                            (js/String.fromCharCode.apply nil))
                        response)]
     (assoc db :brand-logo (->> response-str
                                js/btoa
                                (str "data:image/" image-type ";base64,"))))))

(rf/reg-event-fx
 ::start-watch-alerts
 (fn [_ [_ asset-id scale-number ip-address frequency-ms]]
     {::fx/interval {:action :start
                     :id ::watch-alerts
                     :frequency (or frequency-ms 60000)
                     :event [:fetch/data
                             (if asset-id
                               [:alerts asset-id]
                               [:all-alerts])
                             "/api/alerts/"
                             (when asset-id
                               {:asset asset-id :scale-number scale-number :ip-address ip-address})]}}))

(rf/reg-event-fx
 ::stop-watch-alerts
 (fn [_ _]
   {::fx/interval {:action :stop
                   :id ::watch-alerts}}))

(defn path-param
  [db k]
  (get-in db [:current-route :path-params k]))

(rf/reg-event-fx
 :init
 [(rf/inject-cofx :store)]
 (fn [{:keys [store]} _]
   (let [show-menu? (get store
                         :show-menu?
                         (common/media-query [:min-width "medium"]))]
     {::logging/start-aws-logger [config/aws-access-key-id
                                  config/aws-secret-access-key
                                  config/aws-region
                                  config/aws-log-group-name]
      :load-highlight-js config/debug?
      :fx [[:dispatch-n [[::rp/set-keydown-rules
                          {:event-keys [(when config/debug?
                                          [ ;; dispatch :debug-toggle if
                                           [:debug-toggle]
                                           ;; ctrl + del key are pressed
                                           [{:keyCode 46
                                             :ctrlKey true}]])
                                        ;; Whilst we're still demoing
                                        [[::show-hide-dev-options]
                                         [{:keyCode 88
                                           :altKey true}]]]
                           :clear-keys
                           ;; will clear the previously recorded keys if
                           [ ;; escape
                            [{:keyCode 27}]
                            ;; or Ctrl+g are pressed
                            [{:keyCode   71
                              :ctrlKey true}]]}]]]
           (if (authn/is-authenticated? store)
             [:dispatch-n [[::load-openapi]
                           [::get-user]
                           [::get-users]
                           [::get-dealerships]]]
             [:dispatch [:token-expired]])]
      :db (assoc store :show-menu? show-menu?)})))

(rf/reg-event-db
 ::show-hide-dev-options
 (fn [db _]
   (update db :dev-options? not)))

(rf/reg-event-fx
 ::get-user
 (fn [{:keys [db]} _]
   (if-let [user-id (site/to-plain-id (get-in db [:authentication :user]))]
     (ajax/get-request
      (str config/site-api-origin "/api/user")
      [::get-user-success]
      [:generic-failure])
     (js/console.error "No user id in authentication response"))))

(rf/reg-event-fx
 ::get-user-success
 [
  ;; dispatch-get-image
  dealership-image-data-interceptor
  (rf/inject-cofx :store)]
 (fn [{:keys [store db]} [_ response]]
   {:db (-> db
            (assoc-in  [:ajax-data :current-user] response)
            (update-in [:ajax-data :users]
                       potpuri/update-first
                       {:crux.db/id (:crux.db/id response)}
                       (constantly response)))
    :store (assoc store :username (:juxt.pass.alpha/username response))
    ::logging/update-log-stream-name nil ;; TODO Remove this effect
    :fx [[:dispatch [::sse/listen response]]]}))

(rf/reg-event-fx
 ::get-users
 (fn [{:keys [db]} _]
   (ajax/get-request
    (str config/site-api-origin "/api/users/")
    [::fetch-data-success [:users]]
    [::fetch-data-failure [:users]])))

(rf/reg-event-fx
 ::get-dealerships
 (fn [{:keys [db]} _]
   (ajax/get-request
    (str config/site-api-origin "/api/orgs/")
    [::fetch-data-success [:dealerships]]
    [::fetch-data-failure [:dealerships]])))

(rf/reg-event-fx
 ::load-openapi
 (fn [_ _]
   (ajax/get-request
    (str config/site-api-origin "/_site/apis/rlws/openapi.json")
    [::fetch-data-success [:openapi]]
    [::fetch-data-failure [:openapi]])))

(rf/reg-fx
 :load-highlight-js
 (fn [debug?]
   (when debug?
     (let [js-element (js/document.createElement "script")
           css-element (js/document.createElement "link")]
       (set! (.-src js-element) "/js/highlight.pack.js")
       (set! (.-id js-element) "highlight-js")
       (set! (.-href css-element) "/css/highlight-pack.css")
       (set! (.-rel css-element) "stylesheet")
       (set! (.-onload js-element)
             #(rf/dispatch [:highlight-js-loaded]))
       (js/document.body.appendChild js-element)
       (js/document.body.appendChild css-element)))))

(rf/reg-event-db
 :highlight-js-loaded
 (fn [db _]
   (assoc db :highlight-js-loaded? true)))

(rf/reg-event-db
 :debug-toggle
 (fn [db _]
   (update db :debug? not)))

(rf/reg-event-fx
 :menu-toggle
 [(rf/inject-cofx :store)]
 (fn [{:keys [db store]} _]
   (let [new-value (not (get db :show-menu?))]
     {:db (assoc db :show-menu? new-value)
      :store (assoc store :show-menu? new-value)})))

(rf/reg-event-db
 :modal
 (fn [db [_ data]]
   (assoc db :modal data)))

(rf/reg-event-db
 :close-modal
 (fn [db _]
   (dissoc db :modal-component)))

(rf/reg-event-fx
 :toggle-settings
 (fn [{:keys [db]} _]
   (let [show? (not (:settings-popover db))]
     {:db (assoc db :settings-popover show?)
      :fx [[:dispatch-later [{:ms 10
                              :dispatch [:set-entered :settings show?]}]]]})))

(rf/reg-event-db
 :set-entered
 (fn [db [_ key show?]]
   (assoc-in db [:entered key] show?)))

(rf/reg-event-fx
 :login
 (fn [{:keys [db]} [_ {:keys [values path] :as props}]]
   (let [basic-auth (str "Basic " (js/btoa (str (:user values) ":" (:password values))))]
     {:http-xhrio
      {:uri (str config/site-api-origin "/_site/token")
       :method :post
       :format (ajax.core/url-request-format)
       :params values
       :response-format ajax-common/detect-response-format
       :headers {"Authorization" basic-auth}
       :on-success [:login-success path]
       :on-failure [:generic-form-failure props]}
      :db (fork/set-submitting db path true)})))

(rf/reg-event-fx
 :oauth-login
 (fn [{:keys [db]} [_ auth-code]]
   (if (nil? auth-code)
     {:db (fork/set-server-message db :fork.re-frame/global "Failed to Login with Auth0")
      :fx [[:dispatch [:navigate :login]]]}
     {:http-xhrio
      {:uri (str config/site-api-origin "/_site/token")
       :method :post
       :format (ajax.core/url-request-format)
       :response-format ajax-common/detect-response-format
       :headers {"Authorization" (str "Bearer " auth-code)}
       :on-success [:login-success nil]
       :on-failure [:generic-form-failure nil]}})))

(rf/reg-event-fx
 :token-expired
 (fn [{:keys [db]} _]
   {:db (fork/set-server-message db :fork.re-frame/global "Session timed out")
    :fx [[:dispatch [:navigate :login]]]}))

(defn post-auth-dispatch
  [landing-url]
  (let [next (common/next-url)]
    (cond
      (some? landing-url)
      [:visit! landing-url]

      (some? next)
      (let [route (if (navigation/url->route next)
                    next
                    (navigation/route->url next))
            build-location
            (fn [uri]
              ;; Remove next query param now that we've consumed it
              (let [params (str (doto (common/search-params)
                                      (.delete "next")))]
                (str uri
                     (when-not (str/blank? params)
                       (str "?" params)))))]
        [:visit! (build-location (if route route next))])

      :else
      [:navigate config/home-route])))

(rf/reg-event-fx
 :login-success
 (fn [{:keys [db]}
      [_ path response]]
   (let [dispatch-action (post-auth-dispatch nil)]
     {:fx [[:dispatch-n [[::authn/store-token response]
                         dispatch-action
                         [:init]]]]
      :db (fork/set-submitting db path false)})))


(rf/reg-event-fx
 :signup
 (fn [{:keys [db]} [_ {:keys [values path] :as props}]]
   (assoc
    (ajax/post-request
     (str config/site-api-origin "/signup")
     values
     [:login-success path]
     [:generic-form-failure props])
    :db
    (fork/set-submitting db path true))))

(rf/reg-event-fx
 :signup-success
 (fn [{:keys [db]}
      [_ {:keys [user landing-url]}]]
   (let [dispatch-action (post-auth-dispatch landing-url)]
     {:fx [[:dispatch dispatch-action]]
      :db (fork/set-submitting db :form false)})))

(rf/reg-event-fx
 :logout
 [(rf/inject-cofx :store)]
 (fn [{:keys [db store]} _]
   ;; Shred the db and navigate to login, leaving sse connection so we can close
   ;; it correctly
   {:db (select-keys db [:event-source])
    ::logging/update-log-stream-name nil ;; TODO Remove this effect
    :store (-> store
               (dissoc :authentication)
               (assoc :username "not-logged-in-user"))
    ::fx/interval {:action :stop-all}
    :fx [[:dispatch-n [[:navigate :login]
                       [::sse/close]]]]}))

(rf/reg-event-fx
 :global-message/add
 (fn [{:keys [db]} [_ message]]
   {:db (update db :global-messages #(cons %2 %1) message)
    :fx [[:dispatch-later [{:ms 5000
                            :dispatch [:global-message/dismiss]}]]]}))

(rf/reg-event-db
 :global-message/dismiss
 (fn [db _]
   (update db :global-messages butlast)))

(rf/reg-event-db
 ::clean-status
 (fn [db _]
   (update db :ajax-data dissoc :status)))

(defn normalize-status
  [status-data asset-id] 
  (if-let [emulation-cell (:emulated-load-cell-number status-data)]
    (update-in status-data
               [:status]
               assoc
               :cells
               (conj
                (:cells (:status status-data))
                {:capability "emulation"
                 :cell-number emulation-cell})
               :number (:number status-data)
               :ip-address (:ip-address status-data)
               :asset-id asset-id)
    (update-in status-data
               [:status]
               assoc
               :number (:number status-data)
               :ip-address (:ip-address status-data)
               :asset-id asset-id)))

(rf/reg-event-fx
 ::set-asset-as-live
 (fn [{db :db} [_ asset-id status]]
   (let [current-timeout (get-in db [:live-assets-inner (str asset-id " " (:number status) " " (:ip-address status))])]
     (js/clearTimeout current-timeout)
     {:db (-> db
              (assoc-in [:live-assets (str asset-id " " (:number status) " " (:ip-address status))] status)
              (assoc-in [:current-scale-status (str asset-id " " (:number status) " " (:ip-address status))] (logic/asset-status-by-id status))
              (assoc-in [:live-assets-inner (str asset-id " " (:number status) " " (:ip-address status))]
                        (js/setTimeout #(rf/dispatch [::clear-asset-as-live asset-id (:number status) (:ip-address status)])
                                       config/asset-liveness-timeout-ms)))})))

(rf/reg-event-db
 ::clear-asset-as-live
 (fn [db [_ asset-id number ip]]
     (when (and (= (:number (:current-status db)) number) (= (:asset-id (:status (:current-status db))) asset-id) (= (:ip-address (:current-status db)) ip))
       (rf/dispatch [::set-current-status nil]))
     (cond-> (update db :live-assets dissoc (str asset-id " " number " " ip))
       (= (get-in db [:ajax-data :asset :gateway]) asset-id) (update :ajax-data dissoc :status)
       true (update :current-scale-status dissoc (str asset-id " " number " " ip)))))

(rf/reg-event-fx
 ::set-live-cells
 (fn [{db :db} [_ load-cell]]
   (if (nil? (get-in db [:live-cells]))
            {:db (-> db 
                     (assoc-in [:live] (js/setTimeout #(rf/dispatch [::set-live]) 5000))
                     (assoc-in [:live-cells (:number load-cell)] load-cell))}
     {:db (-> db (assoc-in [:live-cells (:number load-cell)] load-cell))})))

(rf/reg-event-db
 ::clear-live-cells
 (fn [db [_]] 
   (dissoc db :live-cells)))

(rf/reg-event-db
 ::set-live
 (fn [db [_]]
   (assoc-in db [:live] "Live")))

(rf/reg-event-db
 ::clear-live
 (fn [db [_]]
   (let [timeout (get-in db [:live])]
     (if (not= timeout "Live")
       (do (js/clearTimeout timeout)
           (dissoc db :live))
       (dissoc db :live)))
   ))

(rf/reg-event-fx
  ::unwatch-asset
  (fn [{db :db} [_ asset-id ip-address scale-number]]
    (when-let [user-id (site/to-plain-id (get-in db [:authentication :user]))]
      (ajax/put-request
        (str config/site-api-origin "/_site/users/" user-id)
        (-> (get-in db [:ajax-data :current-user])
            common/remove-internal-keys
            (update :watched-assets (partial remove #{(str asset-id " " scale-number " " ip-address)})))
        [::unwatch-asset-success asset-id]
        [::unwatch-asset-error asset-id]))))

(rf/reg-event-fx
  ::unwatch-asset-success
  (fn [_ [_ asset-id]]
    {:fx [[:dispatch [:global-message/add (global-messages/success "Asset is no longer in the watch list")]]
          [:dispatch [::get-user]]]}))

(rf/reg-event-fx
  ::unwatch-asset-error
  (fn [_ [_ asset-id]]
    {:fx [[:dispatch [:global-message/add (global-messages/error "Asset could not be removed from the watch list")]]]}))

(rf/reg-event-fx
  ::watch-asset
  (fn [{db :db} [_ asset-id ip-address scale-number]]
    (when-let [user-id (site/to-plain-id (get-in db [:authentication :user]))]
      (ajax/put-request
        (str config/site-api-origin "/_site/users/" user-id)
        (-> (get-in db [:ajax-data :current-user])
            common/remove-internal-keys
            (update :watched-assets (comp set conj) (str asset-id " " scale-number " " ip-address)))
        [::watch-asset-success asset-id]
        [::watch-asset-error asset-id]))))

(rf/reg-event-fx
  ::watch-asset-success
  (fn [_ [_ asset-id]]
    {:fx [[:dispatch [:global-message/add (global-messages/success "Asset is now added in the watch list")]]
          [:dispatch [::get-user]]]}))

(rf/reg-event-fx
  ::watch-asset-error
  (fn [_ [_ asset-id]]
    {:fx [[:dispatch [:global-message/add (global-messages/error "Asset could not be added in the watch list")]]]}))

(defn alert-message
  [asset-id scale-number ip-address payload]
  (let [iqubes @(rf/subscribe [::sub/complete-iqubes])
        scales @(rf/subscribe [::sub/complete-scales])
        iqube (first (filterv #(and (= (:ip %) ip-address) (= (:gateway %) asset-id)) iqubes))
        scale (first (filterv #(and (= (:iqube %) (site/to-plain-id iqube)) (= (:gateway %) asset-id) (= (:number %) scale-number)) scales))]
  [:global-message/add
   (global-messages/info
    {:header "New Alert!"
     :body
     [:a {:key (gensym)
          :on-click (fn []
                      (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts asset-id scale-number ip-address])
                      (rf/dispatch [:fetch/data [:alerts asset-id] (site/resource-path :alerts) {:asset asset-id :scale-number scale-number :ip-address ip-address}])
                      (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset asset-id :scale-number scale-number :ip-address ip-address}])
                      (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers (:customer scale))])
                      (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (:site scale))]))
          :href (navigation/id-route
                 :asset
                 {:asset asset-id} {:iqube (site/to-plain-id iqube) :scale (site/to-plain-id scale)}) 
          :style {:color "white"}}
      (str "New Alert for: " (:name scale))]})]))

(rf/reg-event-fx
 ::alert-status
 (fn [{db :db} [_ {:keys [asset-id alert status] :as payload}]]
   (let [iqube @(rf/subscribe [::sub/data :iqube])
         relevant-asset-view? (= asset-id (path-param db :asset))
         [timestamp status-data] status
         relevant-iqube-view? (and (= (path-param db :iqube-detail) (site/to-plain-id iqube)) (= (:gateway iqube) asset-id) (= (:ip-address status-data) (:ip iqube)))]
     (merge
      {:db (if (or relevant-asset-view? relevant-iqube-view?)
             (assoc-in db [:ajax-data :status] [timestamp (normalize-status status-data asset-id)])
             db)
       :fx [[:dispatch [::set-asset-as-live asset-id (:status (normalize-status status-data asset-id))]]
            (when (and relevant-asset-view? alert)
              [:dispatch [:fetch/data [:alerts asset-id] "/api/alerts/" {:asset asset-id :scale-number (:number status-data) :ip-address (:ip-address status-data)}]])
            (when alert
              [:dispatch (alert-message asset-id (:number status-data) (:ip-address status-data) payload)])]}))))

(rf/reg-event-fx
 ::gateway-status
 (fn [{db :db} [_ {:keys [asset-id status]}]]
   {:db (assoc-in db [:live-gateways asset-id] status)
    :fx [[::fx/dispatch-debounced {:key [:gateway-status asset-id]
                                   :event [::unset-gateway-status asset-id]
                                   :ms config/asset-liveness-timeout-ms}]]}))

(rf/reg-event-db
 ::unset-gateway-status
 (fn [db [_ asset-id]]
   (update db :live-gateways dissoc asset-id)))

(rf/reg-event-db
 ::get-asset-success
 (fn [db [_ {:keys [data]}]]
   (assoc-in db [:ajax-data :asset] data)))

(rf/reg-event-fx
 ::asset-success
 (fn [{:keys [db]} [_ path {:keys [data]}]]
   {:db (-> db
            (fork/set-submitting path false)
            (assoc-in [:ajax-data :asset] data))
    :fx [[:dispatch [:modal {:show? false :child nil}]]]}))

(rf/reg-event-fx
 ::add-service-note
 (fn [{:keys [db]} [_ service-note-data]]
   (assoc
    (ajax/put-request
     (str config/site-api-origin "/api/service-notes/" (random-uuid))
     service-note-data
     [::add-service-note-success]
     [:generic-form-failure])
    :db (update-in db [:ajax-data :service-notes] conj service-note-data))))

(rf/reg-event-fx
 ::add-service-note-success
 (fn [{:keys [db]} [_ {:keys [data]}]]
   (let [asset (get-in db [:ajax-data :asset])
         iqube (get-in db [:ajax-data :iqube])
         scale (get-in db [:ajax-data :scale])]
   {:fx [[:dispatch [:modal {:show? false :child nil}]]
         [:dispatch [:global-message/add (global-messages/success "Added Service Note")]]
         [:dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset (:id asset) :scale-number (:number scale) :ip-address (:ip iqube)}]]]})))

(rf/reg-event-fx
 ::edit-service-note
 (fn [{:keys [db]} [_ {:keys [values path] :as props}]]
   (assoc
    (ajax/put-request
     (str "/api/service-notes/" (name (:crux.db/id values)))
     {:note values}
     [::edit-service-note-success path]
     [:generic-form-failure props])
    :db (fork/set-submitting db path true))))

(rf/reg-event-fx
 ::edit-service-note-success
 (fn [{:keys [db]} [_ path {:keys [data]}]]
   (let [id (:crux.db/id data)]
     {:db (-> db
              (fork/set-submitting path false)
              (update-in [:ajax-data :service-notes]
                         (fn [v]
                           (mapv (fn [note]
                                   (if (= (:crux.db/id note) id)
                                     data
                                     note)) v))))
      :fx [[:dispatch [:modal {:show? false :child nil}]]]})))

(rf/reg-event-fx
 ::delete-service-note
 (fn [{:keys [db]} [_ {:keys [values path] :as props}]]
   (let [note-id (:crux.db/id values)]
     (assoc
      (ajax/delete-request
       (str "/api/service-notes/" (name note-id))
       [::delete-service-note-success path]
       [:generic-form-failure props])
      :db
      (fork/set-submitting db path true)))))

(rf/reg-event-fx
 ::delete-service-note-success
 (fn [{:keys [db]} [_ path {:keys [data]}]]
   (let [id (:id data)]
     {:db
      (-> db
          (fork/set-submitting path false)
          (update-in [:ajax-data :service-notes]
                     (fn [v]
                       (filterv #(not= (:crux.db/id %) id) v))))
      :fx [[:dispatch [:modal {:show? false :child nil}]]]})))

(rf/reg-event-fx
 ::send-reset-password-link-success
 (fn [{db :db} _]
   {:db (update-in db [:page-state :login :errors] dissoc :general)
    :fx [[:dispatch [:navigate :login]]
         ;; global message call delayed to stop navigate event wiping the message
         ;; immediately
         [:dispatch-later [{:ms 500
                            :dispatch
                            [:global-message/add
                             (global-messages/success
                              "We have sent an email containing your password reset link. Please use it within the next 15 minutes.")]}]]]}))

(rf/reg-event-fx
 ::send-reset-password-link
 (fn [{db :db} [_ props]]
   (assoc
    (ajax/post-request
     "/reset-password"
     (:values props)
     [::send-reset-password-link-success]
     [:generic-form-failure props])
    :db (assoc db :show-modal-validation false))))

(rf/reg-event-fx
 ::set-password-success
 (fn [{db :db} _]
   {:fx [[:dispatch [:navigate :login]]
         ;; global message call delayed to stop navigate event wiping the message
         ;; immediately
         [:dispatch-later [{:ms 500 :dispatch
                            [:global-message/add
                             (global-messages/success "Password successfully set!")]}]]]
    :db (update-in db [:page-state :login] dissoc :errors)}))

(rf/reg-event-fx
 ::set-password-submit
 (fn [{db :db} [_ props]]
   (let [token (.pop (js/window.location.pathname.split "/"))]
     (assoc
      (ajax/post-request
       (str "/reset-password/" token)
       (:values props)
       [::set-password-success]
       [:generic-form-failure props])
      :db (assoc db :show-modal-validation false)))))

(rf/reg-event-fx
 ::send-device-command
 (fn [{db :db} [_ terminal db-key {:keys [asset-id] :as command}]]
   (assoc
    (ajax/post-request
     (str config/state-api-origin "/api/v1/gateway-command")
     command
     [::send-device-command-success asset-id terminal]
     [::send-device-command-failure asset-id])
    :db (assoc-in db [:device-command asset-id] {:state :pending}))))

(rf/reg-event-fx
 ::send-device-command-success
 (fn [{db :db} [_ asset-id terminal command]]
   ;; FIXME Filthy Hack, TODO Move this into an fx
   (let [edp-response (str
                       (or (get-in command [:success :edp-command-result :success :edp-command-result])
                           (get-in command [:success :edp-command-result])))]
     ((aget @terminal "pushToStdout") edp-response)
     ((aget @terminal "scrollToBottom")))
   {:db (assoc-in db [:device-command asset-id] (assoc command :state :complete))}))

(rf/reg-event-fx
 ::send-device-command-failure
 (fn [{db :db} [_ asset-id response]]
   {:db (assoc-in db [:device-command asset-id] (assoc response :state :error))
    :dispatch [:generic-failure]}))

(rf/reg-event-fx
 ::send-camera-command
 (fn [{db :db} [_ asset-id {:keys [ip] :as camera} parameters]]
   (let [{:keys [image-quality image-resolution]
          :or {image-quality "3"
               image-resolution "640x480"}} parameters
         camera-command {:asset-id asset-id
                         :rlc-secret config/state-secret
                         :command
                         {:device-driver (if (= "1.2.3.4" ip)
                                           :vivotek-sim
                                           :vivotek)
                          :device-command :snapshot

                          :device-args {:ip-address ip
                                        :image-quality image-quality
                                        :image-resolution image-resolution}}}]
     (assoc
      (ajax/post-request
       (str config/state-api-origin "/api/v1/gateway-command")
       camera-command
       [::send-camera-command-success asset-id]
       [::send-camera-command-failure asset-id])
      :db (assoc-in db [:camera-command asset-id] {:state :pending})))))

(rf/reg-event-fx
 ::send-camera-command-success
 (fn [{db :db} [_ asset-id response]]
   {:db (assoc-in db [:camera-command asset-id] (assoc response :state :complete))}))

(rf/reg-event-fx
 ::send-camera-command-failure
 (fn [{db :db} [_ asset-id response]]
   {:db (assoc-in db [:camera-command asset-id] (assoc response :state :error))
    :dispatch [:generic-failure]}))

(rf/reg-event-db
 ::fetch-asset-images-success
 (fn [db [_ response]]
   (update-in db [:ajax-data :images] merge (potpuri/index-by :crux.db/id response))))

(rf/reg-event-fx
 ::fetch-asset-images
 (fn [_ [_ asset-id]]
   (site/get-images-for :assets asset-id [::fetch-asset-images-success])))

(rf/reg-event-fx
 ::add-image
 (fn [_ [_ image-id for-id image-data]]
   (site/add-image image-id for-id image-data)))

(rf/reg-event-fx
 ::add-asset
 (fn [_ [_ {:keys [gateway] :as asset-data}]]
   (site/put-asset asset-data
                   [::add-asset-success gateway]
                   [::add-asset-failure])))

(rf/reg-event-fx
 ::add-asset-success
 (fn [_ _]
   {:fx
    [[:dispatch [:global-message/add (global-messages/success "Added asset")]]
     [:dispatch [:navigate :assets]]]}))

(rf/reg-event-fx
 ::add-asset-failure
 (fn [_ _]
   {:fx
    [[:dispatch [:global-message/add (global-messages/error "Failed to add asset")]]]}))

(rf/reg-event-fx
 ::update-asset
 (fn [_ [_ {:keys [gateway] :as asset-data}]]
   (site/put-asset asset-data
                   [::update-asset-success gateway]
                   [::update-asset-failure])))

(rf/reg-event-fx
 ::update-asset-success
 (fn [_ [_ asset-id]]
   {:fx
    [[:dispatch [:global-message/add (global-messages/success "Updated asset")]]
     [:dispatch [:navigate :asset {:asset asset-id}]]]}))

(rf/reg-event-fx
 ::update-asset-failure
 (fn [_ _]
   {:fx
    [[:dispatch [:global-message/add (global-messages/error "Failed to update asset")]]]}))

(rf/reg-event-fx
 ::delete-asset
 (fn [_ [_ asset]]
   (ajax/delete-request
    (str config/site-api-origin (site/resource-path :assets (site/to-plain-id asset)))
    [::delete-asset-success]
    [::delete-asset-failure])))

(rf/reg-event-fx
 ::delete-asset-success
 (fn [_ _]
   {:fx
    [[:dispatch [:global-message/add (global-messages/success "Deleted asset")]]
     [:dispatch [:navigate :assets]]]}))

(rf/reg-event-fx
 ::delete-asset-failure
 (fn [_ _]
   {:fx
    [[:dispatch [:global-message/add (global-messages/error "Failed to delete Asset")]]]}))

(rf/reg-event-fx
  ::modify-object-success
  (fn [_ [_ message resource]] 
    {:fx 
     [[:dispatch [:global-message/add (global-messages/success message)]]
      [:dispatch [::set-dialog :close]]
      [:dispatch [:fetch/data [resource] (site/resource-path resource)]]]}))

(rf/reg-event-fx
 ::modify-components-success
 (fn [_ [_ message resource asset]]
   {:fx
    [[:dispatch [:global-message/add (global-messages/success message)]]
     [:dispatch [::set-dialog :close]]
     [:dispatch [:fetch/data [resource] (site/resource-path resource)]]
     [:dispatch [:fetch/data [:asset] (site/resource-path :assets (site/to-plain-id asset))]]]}))

(rf/reg-event-fx
 ::modify-notifications-success
 (fn [_ [_ message resource asset]]
   {:fx
    [[:dispatch [:global-message/add (global-messages/success message)]]
     [:dispatch [::set-submitting-notifications false]]
     [:dispatch [:fetch/data [resource] (site/resource-path resource)]]
     [:dispatch [:fetch/data [:asset] (site/resource-path :assets (site/to-plain-id asset))]]]}))

(rf/reg-event-fx
 :generic-success
 (fn [{:keys [db]} [_  message]]
   {:dispatch [:global-message/add (global-messages/success message)]}))

(rf/reg-event-fx
 ::generic-modal-success
 (fn [{:keys [db]} [_ message]]
   {:fx
    [[:dispatch-n [[:modal {:show? false :child nil}]
                   [:global-message/add (global-messages/success message)]
                   (let [params (get-in db [:current-route :path-params])
                         route (key (first params))]
                     [:navigate route params])]]]}))

(rf/reg-event-fx
 :generic-failure
 (fn [{:keys [db]} [_ response]]
   (js/console.error (str "Failed to load " response))
   {:dispatch
    [:global-message/add
     (global-messages/error
      (:status-text response "Internal Error"))]}))

(rf/reg-event-fx
 :generic-form-failure
 (fn [{:keys [db]} [_ props response]]
   (js/console.error (str "Failed to load " response))
   {:db (-> db
            (fork/set-submitting (:path props) false)
            (fork/set-server-message
             (:path props)
             (:status-text response "Internal Error")))}))

(rf/reg-event-fx
 ::delete-data
 (fn [{db :db} [_ url on-success]]
   (ajax/delete-request
    (str config/site-api-origin url)
    (or on-success [:generic-success "Deleted"])
    [:generic-failure])))

(rf/reg-event-fx
 ::put-data
 (fn [{db :db} [_ url data on-success]] 
   (ajax/put-request
    (str config/site-api-origin url)
    data
    (or on-success [:generic-success "Added"])
    [:generic-failure])))

(rf/reg-event-db
 ::update-customer
 (fn [] (rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])))

(rf/reg-event-db
 ::update-site
 (fn [] (rf/dispatch [:fetch/data [:sites] (site/resource-path :sites)])))

(rf/reg-event-db
 ::update-asset
 (fn [] (rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])))

(rf/reg-event-db
 ::update-iqube
 (fn [] (rf/dispatch [:fetch/data [:iqubes] (site/resource-path :iqubes)])))

(rf/reg-event-db
 ::update-scale
 (fn [] (rf/dispatch [:fetch/data [:scales] (site/resource-path :scales)])))

(rf/reg-event-db
 ::set-customer
 (fn [db [_ customer]]
   (assoc db :customer customer)))

(rf/reg-event-db
 ::set-site
 (fn [db [_ site]] 
   (assoc db :site site)))

(rf/reg-event-db
 ::set-customer-tab
 (fn [db [_ tab]]
   (assoc db :customer-tab tab)))

(rf/reg-event-db
 ::set-site-tab
 (fn [db [_ tab]]
   (assoc db :site-tab tab)))

(rf/reg-event-db
 ::set-site-asset-tab
 (fn [db [_ tab]]
   (assoc db :site-asset-tab tab)))

(rf/reg-event-db
 ::set-site-iqube-tab
 (fn [db [_ tab]]
   (assoc db :site-iqube-tab tab)))

(rf/reg-event-db
 ::set-asset-tab
 (fn [db [_ tab]]
   (assoc db :asset-tab tab)))

(rf/reg-event-db
 ::set-dialog
 (fn [db [_ status]] 
   (assoc db :dialog status)))

(rf/reg-event-db
 ::set-selected-gateway
 (fn [db [_ selected]]
     (assoc db :selected-gateway selected)))

(rf/reg-event-db
 ::set-current-status
 (fn [db [_ status]]
   (assoc db :current-status status)))

(rf/reg-event-db
 ::set-selected-scale-type
 (fn [db [_ selected]] 
   (assoc db :selected-scale-type selected)))

(rf/reg-event-db
 ::set-selected-scale-dealership
 (fn [db [_ selected]]
   (assoc db :selected-scale-dealership selected)))


(rf/reg-event-fx
 ::set-current-scale
 (fn [{db :db} [_ scale]]
   (if (not= scale nil)
       {:db (assoc db :current-scale (second (str/split scale " ")))
        :fx [[:dispatch [:fetch/data [:scale] (site/resource-path :scales (second (str/split scale " ")))]]
             [:dispatch [:fetch/data [:asset] (site/resource-path :assets (first (str/split scale " ")))]]
             [:dispatch [:fetch/data [:iqube] (site/resource-path :iqubes (last (str/split scale " ")))]]]}
     {:db (assoc db :current-scale nil)
      :fx [[:dispatch [::set-current-scale-temporary-checkbox nil]]
           [:dispatch [::set-current-scale-temporary-timeout nil]]
           [:dispatch [::set-current-scale-timeout nil]]]})))

(rf/reg-event-db
 ::set-current-scale-timeout
 (fn [db [_ time]]
   (assoc db :current-scale-timeout time)))

(rf/reg-event-db
 ::set-current-scale-temporary-timeout
 (fn [db [_ time]] 
   (assoc db :current-scale-temporary-timeout time)))

(rf/reg-event-db
 ::set-current-scale-temporary-checkbox
 (fn [db [_ value]] 
   (assoc db :current-scale-temporary-checkbox value)))

(rf/reg-event-db
 ::set-submitting-notifications
 (fn [db [_ submit]]
   (assoc db :submitting-notifications submit)))

(rf/reg-event-db
 ::clear-data
 (fn [db [_ ks]]
   (potpuri/dissoc-in db (potpuri/consv ks :ajax-data))))

(rf/reg-event-fx
 :fetch/data
 (fn [_ [_ ks url params]] 
   (ajax/get-request
    (str config/site-api-origin url)
    [::fetch-data-success ks]
    [::fetch-data-failure ks]
    params)))

(rf/reg-event-db
 ::fetch-data-update-success
 (fn [db [_ ks response]]
   (update-in db (potpuri/consv ks :ajax-data) merge (potpuri/index-by site/to-plain-id response))))

(rf/reg-event-fx
 :fetch/data-by-id
 (fn [{:keys [db]} [_ {:keys [ks param url]}]]
   (let [id (path-param db param)]
     (merge
      (ajax/get-request
       (str config/site-api-origin url "/" id)
       [::fetch-data-success ks]
       [::fetch-data-failure ks])
      {:db (assoc-in db (potpuri/conjv ks :ajax-data) nil)}))))

(rf/reg-event-fx
 :fetch/data-by-url-params
 (fn [{:keys [db]} [_ ks url-params url]]
   (let [get-id (fn [id] {id (path-param db id)})]
     (ajax/get-request
      (str config/site-api-origin url)
      [::fetch-data-success ks]
      [::fetch-data-failure ks]
      (into {} (map get-id url-params))))))

(rf/reg-event-db
 ::fetch-data-success
 [
  ;; dispatch-get-image
  dealership-image-data-interceptor]
 (fn [db [_ ks response]]
   (try
     (assoc-in db (potpuri/consv ks :ajax-data) response)
     (catch js/Error e
       (js/console.error "Couldn't update app-db" #js {:ks ks :response response})
       (js/console.error e)
       db))))

(rf/reg-event-fx
 ::fetch-data-failure
 (fn [_ [_ ks]]
   {:fx (cond (:asset (set ks)) [[:dispatch [:global-message/add (global-messages/error "Asset not found")]]
                                 [:dispatch [:navigate :assets]]]
              :else [:dispatch [:generic-failure]])}))

;; NOTE: These are both speculative functions for when we support uploading blob
;; data to site via the web client

(defn data-uri-to-blob
  [data-uri]
  (let [mime-type (re-find #"\w+/\w+" data-uri)
        byte-string (js/atob (second (str/split data-uri #",")))
        array-buffer (js/ArrayBuffer. (count byte-string))
        int-array (js/Uint8Array. array-buffer)]

    (doseq [i (range (count byte-string))]
      (aset int-array i (get array-buffer i)))

    (js/Blob. #js [array-buffer]
              #js {:type mime-type})))

(rf/reg-event-fx
 ::upload-image
 (fn [_ [_ id {:keys [data-uri]} on-success]]
   (let [form-data (js/FormData.)]
     {:http-xhrio
      {:uri (str config/site-api-origin "/images/" id)
       :method "PUT"
       ::authn/type ::authn/bearer
       ::authn/in [:authentication]
       :body (do (. form-data append "file" (data-uri-to-blob data-uri))
                 form-data)
       :response-format ajax-common/detect-response-format
       :headers {"Accept" "application/json"
                 "site-classification" "PUBLIC"}
       :on-success on-success
       :on-failure [::authn/intercept-unauthorized [:generic-failure]]}})))

(rf/reg-event-fx
 ::log-message
 (fn [_ [_ message]]
   {::fx/console.log message}))
